import { p as proxyCustomElement, H, h, c as Host } from './p-CUHLKbRp.js';
import { r as removeSSRSlot } from './p-9wWbaPol.js';
import { d as defineCustomElement$3 } from './p-D5ggpwU6.js';
import { d as defineCustomElement$2 } from './p-CHab5KHD.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.6.0
 */

let sidenavMenuId = 0;
const Sidenav = /*@__PURE__*/ proxyCustomElement(class Sidenav extends H {
    constructor() {
        super();
        this.__registerHost();
        this.sidenavMenuId = `tds-sidenav-menu-${sidenavMenuId++}`;
        /**
         * The label for the sidenav, used for accessibility.
         */
        this.label = "Secondary";
    }
    // --------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    // --------------------------------------------------------------------------
    componentDidLoad() {
        removeSSRSlot(this.el);
    }
    get popoverId() {
        return `${this.sidenavMenuId}-popover`;
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: '656ac0a19fa0c5887461be40178d604670dce5b7', class: "tds-sidenav" }, h("nav", { key: '7e890691fc5282a311b8e510de1781e6d02f6951', id: this.sidenavMenuId, class: "tds-sidenav-nav", "aria-label": this.label }, h("tds-sidenav-responsive-header", { key: '39af43d167cf694121375568c39a9734c5ae8022', "popover-id": this.popoverId, label: this.selectedItemLabel }), h("tds-popover-container", { key: '47c4a53a1e60ea898724a1e236927320c1f109d6', breakpoint: 720, id: this.popoverId, class: "tds-sidenav-collapse", "auto-position": true }, h("div", { key: 'cc270a8ade358ea0e9963a6bf34172f3a3a534bf', class: "tds-sidenav-scroll-container" }, h("slot", { key: '1b99dc126db0edfa390879e3befa292fd279c6ee' }))))));
    }
    get el() { return this; }
}, [6, "tds-sidenav", {
        "label": [1],
        "selectedItemLabel": [1, "selected-item-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav", "tds-popover-container", "tds-sidenav-responsive-header"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, Sidenav);
            }
            break;
        case "tds-popover-container":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "tds-sidenav-responsive-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
const defineCustomElement = defineCustomElement$1;

export { defineCustomElement };
//# sourceMappingURL=tds-sidenav.js.map
